import { ReactElement } from 'react';
import classNames from 'classnames';

import './flip-card.css';

interface Props {
    flipOver: boolean;
    front: ReactElement;
    back: ReactElement;
}

const FlipCard = ({ flipOver, front, back }: Props) => {
    const flipCardClasses = classNames('flip-card', {
        'is-flipped-over': flipOver,
    });

    return (
        <div className={flipCardClasses} data-testid="flipCard">
            <div className="flip-card-front">{front}</div>
            <div className="flip-card-back">{back}</div>
        </div>
    );
};

export default FlipCard;
